module.exports = new __parcel__URL__("lune-nuage-3.9204baa5.svg").toString();